import { setBlockTracking as _setBlockTracking, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0ac887ac"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Made with love by Emkis")
const _hoisted_2 = { class: "SectionFooter__links" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.linkedin.com/in/nicolas-jardim",
  rel: "noopener"
}, "Linkedin", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "http://github.com/emkis",
  rel: "noopener"
}, "GitHub", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconHeart = _resolveComponent("IconHeart")!
  const _component_Heading = _resolveComponent("Heading")!
  const _component_Text = _resolveComponent("Text")!
  const _component_Container = _resolveComponent("Container")!

  return _cache[0] || (
    _setBlockTracking(-1),
    _cache[0] = _createElementVNode("footer", { class: "SectionFooter" }, [
      _createVNode(_component_Container, { class: "SectionFooter__container" }, {
        default: _withCtx(() => [
          _createVNode(_component_IconHeart, {
            size: "54",
            color: _ctx.EThemeConcepts.primaryColor
          }, null, 8, ["color"]),
          _createVNode(_component_Heading, {
            class: "SectionFooter__title",
            level: "3"
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_Text, { as: "span" }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }),
            _createVNode(_component_Text, { as: "span" }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    _setBlockTracking(1),
    _cache[0]
  )
}